import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { adminApi } from '../../lib/adminAuth';
import { Loader2, User, Phone, Mail, Home, ExternalLink, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';

const formatDate = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); }
  catch { return iso; }
};

const AdminInterestsPage = () => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/interests', { params: { limit: 200 } })
      .then((r) => { setItems(r.data.items || []); setTotal(r.data.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Property Interests">
      <div className="bg-white rounded-2xl border border-gray-100 p-4 mb-4">
        <div className="text-sm text-gray-600"><span className="font-bold text-gray-900">{total}</span> total {total === 1 ? 'lead' : 'leads'} received</div>
      </div>

      {loading ? (
        <div className="py-24 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#9a1b2f]" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-16 text-center text-sm text-gray-500">
          <User className="w-8 h-8 text-gray-300 mx-auto mb-2" />
          No property interests yet.
        </div>
      ) : (
        <div className="grid md:grid-cols-2 gap-4">
          {items.map((it) => (
            <div key={it.id} className="bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-md transition">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-full bg-[#fef2f4] flex items-center justify-center">
                      <User className="w-4 h-4 text-[#9a1b2f]" />
                    </div>
                    <div className="min-w-0">
                      <div className="font-bold text-gray-900 truncate">{it.name}</div>
                      <div className="text-[11px] text-gray-500 flex items-center gap-1"><Calendar className="w-3 h-3" /> {formatDate(it.created_at)}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 space-y-1.5 text-sm text-gray-700">
                <div className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-gray-400" /> <a href={`tel:${it.phone}`} className="hover:text-[#9a1b2f]">{it.phone}</a></div>
                {it.email && <div className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-gray-400" /> <a href={`mailto:${it.email}`} className="hover:text-[#9a1b2f]">{it.email}</a></div>}
                {it.message && <div className="text-xs text-gray-600 bg-gray-50 rounded-lg p-2 mt-2">“{it.message}”</div>}
              </div>

              {it.property && (
                <Link to={`/property/${it.property.id}`} target="_blank" rel="noopener noreferrer" className="mt-4 flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-[#9a1b2f] hover:bg-[#fef2f4] transition">
                  <div className="w-14 h-14 rounded-lg overflow-hidden bg-gray-100 shrink-0">
                    <img src={it.property.image} alt="" className="w-full h-full object-cover" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-gray-900 text-sm line-clamp-1">{it.property.name}</div>
                    <div className="text-[11px] text-gray-500 line-clamp-1">{it.property.location}</div>
                    <div className="text-xs font-bold text-[#9a1b2f] mt-0.5">{it.property.price}</div>
                  </div>
                  <ExternalLink className="w-3.5 h-3.5 text-gray-400" />
                </Link>
              )}
              {!it.property && (
                <div className="mt-4 flex items-center gap-2 p-3 rounded-xl border border-gray-100 text-xs text-gray-500">
                  <Home className="w-3.5 h-3.5" /> Property ID: {it.property_id}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
};

export default AdminInterestsPage;
